import React from "react";
import { useNavigate } from "react-router-dom";

import {
  TABLE_DATA,
  TABLE_HEADERS,
  keyMapping,
  topDataList,
} from "../../../../constants/SalesCustomerList";

import ListPage from "../Shared/ListPage";
import ROUTES_NAVIGATION from "../../../../routes/routes";

const OrderExchange = () => {
  const navigate = useNavigate();

  const handleOnAddCustomerButton = () => {
    navigate(ROUTES_NAVIGATION.ADDORDEREXCHANGE);
  };

  const handleOrderExchange = () => {
    navigate(ROUTES_NAVIGATION.VIEWORDEREXCHANGE)
  }

  return (
    <ListPage
    isUploadButtonRequired={false}
      headerTopText="Sales / Order Exchange"
      headerTitle="Order Exchange"
      addButtonTitle="Add Cancel Exchange"
      listTitle="All Customers"
      topDetailsList={topDataList}
      tableData={TABLE_DATA}
      tableHeaders={TABLE_HEADERS}
      keyMapping={keyMapping}
      handleOnAddButton={handleOnAddCustomerButton}
      handleOnUploadButton={() => {}}
      handleViewButton={handleOrderExchange}
    />
  );
};

export default OrderExchange;
